import { useAppSelector } from "@/store/store";
import { useDispatch } from "react-redux";
import { UserExperimentsApi } from "../server/agent";
import { UserExperimentsActionCreators } from "../store/action-creators/userExperimentsActions";
import {
  selectIsAuth,
  selectLastStep,
  selectNullableApplicationId,
} from "../store/selectors";
import { useEffectAsync } from "./useEffectAsync";

export const useUserExperiments = () => {
  const dispatch = useDispatch();
  const isAuth = useAppSelector(selectIsAuth);
  const applicationId = useAppSelector(selectNullableApplicationId);
  const lastStep = useAppSelector(selectLastStep);

  useEffectAsync(
    async (signal: AbortSignal) => {
      if (!isAuth || !applicationId) {
        dispatch(UserExperimentsActionCreators.resetGroups());
        return;
      }

      const res = await UserExperimentsApi.getGroups(applicationId, { signal });
      if (!res || !res.result) {
        dispatch(UserExperimentsActionCreators.resetGroups());
        return;
      }

      dispatch(UserExperimentsActionCreators.setGroups(res.data));
    },
    [isAuth, applicationId, lastStep],
    { debounce: 200 }
  );
};
